import { getItemFromCollection, getItemsFromCollection } from "directus/src/operations";

export async function fetchClientDetails({ clientId }) {
    try {
        const query = {
            fields: [
                "id",
                "status",
                "name",
                "first_name",
                "last_name",
                "type",
                "sales_channel.id",
                "sales_channel.name",
                "mobile_number",
                "email",
                "company_id.id",
                "company_id.name",
                "job_title.id",
                "job_title.name",
                "linkedin",
                "discord",
                "slack",
                "whatsapp",
                "telegram",
                "facebook",
                "skype",
                "opportunity_id",
                "about",
                "code",
                "user",
            ],
        };
        const response = await getItemFromCollection("clients", clientId, query);
        return response;
    } catch (error) {
        console.error("Error fetching client details:", error);
        throw error;
    }
}
